import {TYPE_COLUMN_HIGH_CHART} from '@/containers/E4ImpactMBA/resources/config-schema';
import {IConfigSchema, TYPE_COLUMN_TABLE} from '@/containers/E4ImpactProjects/resources/config-schema';
import {entrepreneurMindsetChartCalculation} from './chart-calculations/entrepreneur-mindset-chart-calculation';
import {increasedSkillsChartCalculation} from './chart-calculations/increased-skills-chart-calculation';
import {contributionChartCalculation} from './chart-calculations/contribution-chart-calculation';
import {entrepreneurMindsetTableCalculation} from './table-caclulations/entrepreneur-mindset-table-calculation';
import {increasedSkillsTableCalculation} from './table-caclulations/increased-skills-table-calculation';

export const configSchema = (props: any): IConfigSchema => ([
    {
        rows: [
            {
                columns: [
                    {
                        title: 'Entrepreneurs increase their entrepreneurial mindset and orientation',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: entrepreneurMindsetChartCalculation(props),
                    },
                    {
                        title: '% INCREASED SKILLS (PER MACRO-AREA)',
                        typeChart: TYPE_COLUMN_TABLE,
                        transformData: entrepreneurMindsetTableCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: 'Entrepreneurs increase their entrepreneurial mindset and orientation',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: increasedSkillsChartCalculation(props),
                    },
                    {
                        title: '% INCREASED SKILLS',
                        typeChart: TYPE_COLUMN_TABLE,
                        transformData: increasedSkillsTableCalculation(props),
                    }
                ]
            },
            {
                columns: [
                    {
                        title: 'E4Impact contribution for results achieved',
                        typeChart: TYPE_COLUMN_HIGH_CHART,
                        transformData: contributionChartCalculation(props),
                    },
                ]
            },
        ]
    }
]);